import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Navbar from "./Navbar";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { cards } from "../components/SliderComp";
import Footer from "../components/Footer";
import BackToTop from "../components/BackToTop";
import { motion } from "framer-motion";
import '../css/blog.css';
import { FaChevronLeft, FaChevronRight } from "react-icons/fa"; // Import arrows

import greenathan1 from '../assets/Greenathan/1.jpg';
import '../css/project.css';
import '../css/home.css';

const SubProjects = () => {
    const { id } = useParams();
    const { cardId, projectId } = useParams();
    const [card, setCard] = useState(null);
    const [loading, setLoading] = useState(true);
  
    const [activeIndex, setActiveIndex] = useState(0);
    const navigate = useNavigate();
    const [currentIndex, setCurrentIndex] = useState(0);
  
    const selectedCard = cards.find((card) => card.id === parseInt(cardId));
    const selectedProject = selectedCard?.projects.find((project) => project.id === parseInt(projectId));
    
  
    const handleNext = () => {
      setActiveIndex((prevIndex) => (prevIndex + 1) % selectedProject.galleries.length);
    };
  
    const handlePrev = () => {
      setActiveIndex((prevIndex) =>
        prevIndex === 0 ? selectedProject.galleries.length - 1 : prevIndex - 1
      );
    };
  
    // // Auto-slide functionality
    // useEffect(() => {

        
    //     console.log("cardId, projectId", cardId, projectId);
    //     console.log("Select Project===>", selectedProject);

    //   const autoSlide = setInterval(() => {
    //     handleNext();
    //   }, 5000); // Change slides every 5 seconds
  
    //   return () => clearInterval(autoSlide); // Cleanup on component unmount
    // }, []);
   
  
    const nextSlide = () => {
      setCurrentIndex((prevIndex) =>
        prevIndex + 1 >= selectedProject.length ? 0 : prevIndex + 1
      );
    };
  
    const prevSlide = () => {
      setCurrentIndex((prevIndex) =>
        prevIndex - 1 < 0 ? selectedProject.length - 1 : prevIndex - 1
      );
    };
  
    useEffect(() => {
      const interval = setInterval(nextSlide, 4000); // Auto-slide every 4 seconds
      return () => clearInterval(interval);
    }, [selectedProject.length]);
  
  
  
    const handleBlogClick = (id) => {
      // navigate(`/blog/${id}`);
    };
    return (
      <>
        <Navbar />
  
        {/* Hero Section */}
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            width: "100%",
            minHeight: "70vh",
            padding: "5vw",
            alignItems: "center",
            justifyContent: "center",
            background: "#f3f2f3",
            gap: "20px",
          }}
        >
          {/* Left Section - Title & Description */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 1 }}
            style={{
              flex: "1",
              minWidth: "300px",
              maxWidth: "500px",
              textAlign: "center",
            }}
          >
            <h1
              style={{
                fontSize: "clamp(2rem, 4vw, 3rem)",
                fontWeight: "bold",
                color: "#333",
              }}
            >
              {selectedProject.title}
            </h1>
  
          </motion.div>
  
          {/* Right Section - Project Image */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 1.5 }}
            style={{
              flex: "1",
              minWidth: "300px",
              maxWidth: "550px",
              borderRadius: "12px",
              overflow: "hidden",
              boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
            }}
          >
            <img
              src={selectedProject.image1}
              alt="Project"
              loading="lazy"
              style={{
                width: "100%",
                height: "auto",
                objectFit: "cover",
                borderRadius: "12px",
              }}
            />
          </motion.div>
        </div>
  
        {/* Project Description Section */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5, duration: 1 }}
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
            width: "100%",
            padding: "40px 5vw",
          }}
        >
          <h2
            style={{
              fontSize: "clamp(2rem, 3vw, 2.5rem)",
              fontWeight: "bold",
              color: "#333",
              marginBottom: "15px",
              textTransform: "uppercase",
              letterSpacing: "1.5px",
            }}
          >
            About the Project
          </h2>
          <p
            className="text-gray-600"
            style={{
              maxWidth: "800px",
              fontSize: "clamp(1rem, 1.5vw, 1.2rem)",
              lineHeight: "1.8",
              color: "#555",
            }}
          >
            {selectedCard.text}
          </p>
        </motion.div>
        {/* Blog Section */}
        <div
          style={{
            width: "100%",
            padding: "40px 5vw",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
            textAlign: "center",
            position: "relative",
            background: "#FEF6F3"
  
          }}
        >
          <div className="home-ninth-section">
            <div className="ninth-container" style={{
              width: '100%'
            }}>
              <div className="ninth-upper-container">
                <h4>Our Blog</h4>
                <h2>Latest Photos & Galleries</h2>
                <p>
                  {selectedProject.title} project contains numerous photo galleries.
                </p>
              </div>
            </div>
          </div>
  
          <div
            style={{
              display: "flex",
              gap: "20px",
              overflow: "hidden",
              width: "80%",
              flexWrap: "wrap",
              justifyContent: "center",
            }}
          >
            {selectedProject.galleries.slice(activeIndex, activeIndex + 3).map((blog) => (
              <motion.div
                key={blog.id}
                initial={{ opacity: 0, x: 50 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.5 }}
                style={{
                  flex: "1",
                  minWidth: "280px",
                  maxWidth: "380px",
                  borderRadius: "12px",
                  overflow: "hidden",
                  boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
                  textAlign: "center",
                  background: "#fff",
                  paddingBottom: "20px",
                }}
                onClick={() => handleBlogClick(blog.id)}
              >
                <img
                  src={blog.image}
                  alt={blog.id}
                  style={{
                    width: "100%",
                    height: "200px",
                    objectFit: "cover",
                  }}
                />
                {/* <h3
                  style={{
                    fontSize: "1.5rem",
                    margin: "10px 0",
                    color: "#333",
                  }}
                >
                  {blog.title}
                </h3>
                <p
                  style={{
                    fontSize: "1rem",
                    color: "#666",
                    padding: "0 10px",
                  }}
                >
                  {blog.description}
                </p> */}
              </motion.div>
            ))}
          </div>
  
          {/* Custom Left Arrow */}
          <button
            onClick={handlePrev}
            style={{
              position: "absolute",
              left: "2vw",
              cursor: "pointer",
              background: "rgba(0, 0, 0, 0.3)",
              border: "none",
              padding: "10px",
              borderRadius: "50%",
              transition: "all 0.3s ease",
              display: activeIndex === 0 ? "none" : "block",
            }}
          >
            <FaArrowLeft size={30} color="#fff" />
          </button>
  
          {/* Custom Right Arrow */}
          <button
            onClick={handleNext}
            style={{
              position: "absolute",
              right: "2vw",
              cursor: "pointer",
              background: "rgba(0, 0, 0, 0.3)",
              border: "none",
              padding: "10px",
              borderRadius: "50%",
              transition: "all 0.3s ease",
              display: activeIndex + 3 >= selectedProject.galleries.length ? "none" : "block",
            }}
          >
            <FaArrowRight size={30} color="#fff" />
          </button>
        </div>
  
  
        <Footer />
        <BackToTop />
      </>
    );
  
  };

  export default SubProjects;